import { useNavigate, useRouterState } from "@tanstack/react-router";
import { openWindow } from "./dock";

/** Opens a conversation where it fits: a docked window on desktop, the full chat view on phones or inside /chat. */
export function useOpenChat(isPhone: boolean) {
  const navigate = useNavigate();
  const path = useRouterState({ select: (st) => st.location.pathname });
  return (channelId: string) => {
    if (isPhone || path.startsWith("/chat")) void navigate({ to: "/chat/$channelId", params: { channelId } });
    else openWindow(channelId);
  };
}
